import Vue from 'vue'
import Vuex from 'vuex'
import sharedUtils from '../shared/utils.js'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    game: null,
    player: null,
    gotoNextGame: false
  },
  getters: {
    isGameAdmin (state) {
      return state.game && state.player && state.game.admin_player === state.player.id;
    },
    gameAdminName (state, getters) {
      if (!state.game) { return 'the admin'; }
      for (let i = 0; i < getters.gamePlayers.length; i++) {
        if (getters.gamePlayers[i].id === state.game.admin_player) { return getters.gamePlayers[i].name; }
      }
      return 'the admin';
    },
    gamePlayers (state) {
      if (state.game && state.game.players) { return state.game.players; }
      return [];
    },
    gamePlayerHand (state) {
      if (state.player && state.player.hand) {
        return sharedUtils.handFromString(state.player.hand);
      }
      return [];
    },
    gameHasEnded (state) {
      return state.game.has_ended !== '_';
    },
    nextGameAuth (state, getters) {
      if (getters.gameHasEnded && state.game.game_next != '') { return state.game.game_next; }
      return '';
    },
    tileColor: (state) => (tile) => {
      if (!state.game) { return ''; }
      return state.game.tile_claims.charAt(tile);
    },
    currentPlayer (state, getters) {
      if (!state.game || !state.player) { return null; }
      if (state.game.position_turn === state.player.position) { return state.player; }
      for (let i = 0; i < getters.gamePlayers.length; i++) {
        if (getters.gamePlayers[i].position === state.game.position_turn) { return getters.gamePlayers[i]; }
      }
      return null;
    },
    playerTurnText (state, getters)  {
      if (!state.game || !state.player) { return ''; }
      if (getters.gameHasEnded) {
        if (state.game.has_ended === 'r') { return 'Red wins!'; }
        if (state.game.has_ended === 'g') { return 'Green wins!'; }
        if (state.game.has_ended === 'b') { return 'Blue wins!'; }
      }

      const currentPlayer = getters.currentPlayer;
      if (!currentPlayer) { return ''; }

      let playerName = currentPlayer.name;
      playerName += playerName.charAt(playerName.length-1).toLowerCase() == 's' ? "'" : "'s";
      if (currentPlayer.id == state.player.id) { playerName = 'your'; }
      return "It's " + playerName + " turn";
    },
    topDiscardPlayer (state, getters) {
      const currentPlayer = getters.currentPlayer;

      // If there is a pending chain, then the current player has played a discard...
      if (getters.pendingChain.length) { return currentPlayer; }

      let lastDiscardPosition = currentPlayer.position - 1;
      if (lastDiscardPosition < 1) { lastDiscardPosition = state.game.position_count; }

      const gamePlayers = getters.gamePlayers;
      for (let i = 0; i < gamePlayers.length; i++) {
        if (gamePlayers[i].position === lastDiscardPosition) { return gamePlayers[i]; }
      }
      return null;
    },
    topDiscardCard (state, getters) {
      const discardPlayer = getters.topDiscardPlayer;
      return discardPlayer && discardPlayer.discard ? discardPlayer.discard : 'WW';
    },
    topDiscardColor (state, getters) {
      const discardPlayer = getters.topDiscardPlayer;
      if (!discardPlayer || !discardPlayer.discard) { return 'black'; }
      if (discardPlayer.color === 'b') { return 'blue'; }
      if (discardPlayer.color === 'g') { return 'green'; }
      if (discardPlayer.color === 'r') { return 'red'; }
      return 'black';
    },
    isPlayerTurn (state) {
      return (state.game && state.player && state.game.position_turn == state.player.position);
    },
    pendingChain (state) {
      if (!state.game || state.game.chain_pending === '') { return []; }
      return state.game.chain_pending.split(',').map(function (t) { return parseInt(t); });
    }
  },
  mutations: {
    setGameState (state, game) { Vue.set(state, 'game', game); },
    setPlayerState (state, player) { Vue.set(state, 'player', player); },
    gotoNextGame (state, ready) { Vue.set(state, 'gotoNextGame', ready); }
  },
  actions: {
    setPlayerColor (context, payload) {
      console.log('player_set_color', payload);
      Vue.prototype.$socket.emit('player_set_color', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
        args: payload // { id: playerId, color: playerColor }
      });
    },

    playerTakeTurn (context, payload) {
      console.log('player_turn', payload);
      Vue.prototype.$socket.emit('player_turn', {
      // Vue.prototype.$socket.emit('mark_card', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
        args: payload // { card: '9D', tile: 95 }
      });
    },

    playerSelectChain (context, payload) {
      console.log('player_chain', payload);
      Vue.prototype.$socket.emit('player_chain', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
        args: payload // { chain: [15, 25, 35, 45, 55] }
      });
    },

    playerDrawCard (context) {
      console.log('player_draw');
      Vue.prototype.$socket.emit('player_draw', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
      });
    },

    playerDeadCard (context, payload) {
      console.log('player_dead', payload);
      Vue.prototype.$socket.emit('player_dead', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
        args: payload // { card: '9D' }
      });
    },

    newGame (context, playerName) {
      let playerAuth = context.state.player ? context.state.plater.auth_token : '';
      if (!playerAuth) {
        let playerInfo = Vue.$cookies.isKey('cgp') ? Vue.$cookies.get('cgp').split('|') : [];
        playerAuth = playerInfo.length > 0 ? playerInfo[0] : '';
      }

      let player = { name: playerName };
      if (playerAuth) { player.auth = playerAuth; }

      console.log('game_new', { player: player });
      Vue.prototype.$socket.emit('game_new', { player: player });
    },

    joinGame (context, payload) {
      let playerAuth = context.state.player ? context.state.plater.auth_token : '';
      if (!playerAuth) {
        let playerInfo = Vue.$cookies.isKey('cgp') ? Vue.$cookies.get('cgp').split('|') : [];
        playerAuth = playerInfo.length > 0 ? playerInfo[0] : '';
      }

      let player = { name: payload.playerName };
      if (playerAuth) { player.auth = playerAuth; }

      console.log('game_join', { game: { auth: payload.game }, player: player });
      Vue.prototype.$socket.emit('game_join', { game: { auth: payload.game }, player: player });
    },

    startGame (context, payload) {
      console.log('game_start', payload);
      Vue.prototype.$socket.emit('game_start', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
        teams: payload.teams,
        show_last_tile: 'show_last_tile' in payload && payload.show_last_tile ? 1 : 0,
      });
    },

    nextGame (context) {
      context.commit('gotoNextGame', true);
      Vue.prototype.$socket.emit('game_next', {
        auth: { game: context.state.game.auth_token, player: context.state.player.auth_token },
      });
    },

    cgsock_gameState (context, gameState) {
      // Check to ensure that either the user isn't currently playing a game or game state matches the route...
      const loadedGame = router.currentRoute.params.gameAuth ? router.currentRoute.params.gameAuth : '';
      if (loadedGame !== '' && gameState.auth_token !== loadedGame) { return; }

      // If the game has ended, remove the game cookie so it won't be pre-populated on next form load...
      if (gameState.has_ended !== '_') { Vue.$cookies.remove('cgg'); }

      // Otherwise, set a game cookie so if they return to home page they can get back to game...
      else { Vue.$cookies.set('cgg', gameState.auth_token); }

      context.commit('setGameState', gameState);

      // Update the game url in the browser
      if (loadedGame !== gameState.auth_token) {
        router.push('/g/' + gameState.auth_token);
      }

      else if (context.state.gotoNextGame && gameState.game_next) {
        router.push('/g/' + gameState.game_next);
      }
    },

    cgsock_playerState (context, playerState) {
      Vue.$cookies.set('cgp', playerState.auth_token + '|' + playerState.name);
      context.commit('setPlayerState', playerState);
    },

    cgsock_rejoin (context) {
      // Only rejoin the game if they are on the game link for the game loaded into app.
      const loadedGame = router.currentRoute.params.gameAuth ? router.currentRoute.params.gameAuth : '';
      if (!loadedGame || !context.state.game || !context.state.player) { return; }
      if (loadedGame !== context.state.game.auth_token) { return; }

      console.log('game_join');
      Vue.prototype.$socket.emit('game_join',
        { game: { auth: context.state.game.auth_token }, player: { auth: context.state.player.auth_token } });
    },

    cgsock_error (context, error) { alert(error.message); }
  },
  modules: {
  }
})
